var _path, _circle, _ellipse, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagicLinkWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 89,
    viewBox: "0 0 52 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8939 41.3866C30.8942 40.5428 30.6763 39.7133 30.2614 38.9786C29.8465 38.2438 29.2486 37.6289 28.5259 37.1934C27.8032 36.7579 26.9802 36.5167 26.1367 36.4931C25.2933 36.4696 24.4581 36.6645 23.7122 37.059C22.9663 37.4535 22.3351 38.0341 21.8799 38.7446C21.4246 39.455 21.1608 40.2711 21.114 41.1135C21.0672 41.956 21.239 42.7963 21.6128 43.5528C21.9865 44.3092 22.5496 44.9562 23.2472 45.4309V56.0679H28.7523V45.4309C29.4122 44.9827 29.9524 44.3798 30.3257 43.6749C30.699 42.9699 30.8941 42.1843 30.8939 41.3866Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#DC3232"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.3894,
    cy: 81.8926,
    rx: 18,
    ry: 7,
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27294_108341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6327 36.8334C32.6157 36.8334 37.466 31.9832 37.466 26.0001C37.466 20.017 32.6157 15.1667 26.6327 15.1667C20.6496 15.1667 15.7993 20.017 15.7993 26.0001C15.7993 31.9832 20.6496 36.8334 26.6327 36.8334Z",
    stroke: "white",
    strokeWidth: 3.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6328 30.3333H26.6436",
    stroke: "white",
    strokeWidth: 3.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6328 21.6667V26.0001",
    stroke: "white",
    strokeWidth: 3.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27294_108341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(13.6328 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicLinkWarning);
export default __webpack_public_path__ + "static/media/magic-link-warning.c400e57122562e98a4b00f7eb73a2dd2.svg";
export { ForwardRef as ReactComponent };